import { ApplicationController, useDebounce } from "stimulus-use";

// Connects to data-controller="auto-submit"
export default class extends ApplicationController {
  static values = {
    debounce: {
      type: Number,
      default: 300
    }
  };
  static targets = ["input", "form", "cross", "count", "results"];
  static debounces = ["submit"];

  connect() {
    useDebounce(this, { wait: this.debounceValue });
  }

  submit() {
    this.#submit();
  }

  submitWithoutDebounce() {
    this.#submit();
  }

  reset() {
    this.inputTarget.value = "";
    this.#submit();
    this.inputTarget.focus();
  }

  #submit() {
    this.formTarget.requestSubmit();

    if (this.hasInputTarget && this.hasCrossTarget) {
      if (this.inputTarget.value === "") {
        this.crossTarget.classList.add("hidden");
      } else {
        this.crossTarget.classList.remove("hidden");
      }

      this.inputTarget.parentNode.dataset.active = !(
        this.inputTarget.value === ""
      );
    }

    if (this.hasCountTarget) {
      this.#setCount();
    }
  }

  #waitForSubmit() {
    return new Promise((resolve) => {
      document.addEventListener("turbo:frame-load", () => resolve("resolved"));
    });
  }

  async #setCount() {
    await this.#waitForSubmit();
    this.countTarget.innerText = `(${this.resultsTarget.dataset.count})`;
  }
}
